// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { get } from "@insite/client-framework/Services/ApiService";

export interface MediaData {
    id: string;
    userName: string;
    caption: string;
    mediaType: string;
    permaLink: string;
    mediaUrl: string;
    timeStamp: Date;
}

export interface MediaDataCollection {
    success: boolean;
    data: MediaData[];
}

const serviceUri = "api/custom/Instagram/GetMediaData";

export async function getMediaData() {
    const mediaData = await get<MediaDataCollection>(`${serviceUri}`).catch(err => err);
    return mediaData;
}
